import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BreadcrumbItem } from './breadcrumb-items';

@Component({
  selector: 'lib-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BreadcrumbsComponent {
  @Input()
  breadCrumbItems: BreadcrumbItem[];

  trackByFn(index) {
    return index;
  }
}
